import kreis from "./kreis.png";
import linie from "./linie.png";
import React, { useState } from "react";
import "antd/dist/antd.css";
import { Row, Col } from "antd";
import { Radio, Space } from "antd";
import imageMapResize from "image-map-resizer";

import "./App.css";
import react from "react";

const App = () => {
  const textmain = {
    text: "Während ihres Lebenszyklus durchlaufen Produkte verschiedene Phasen. In jeder dieser Phasen werden Ressourcen verbraucht, wodurch sogenannte Umweltwirkungen, z. B. Treibhausgasemissionen, entstehen. Viele Produkte durchlaufen ihren Lebenszyklus in kurzer Zeit und werden danach entsorgt, wodurch große Umweltlasten und oftmals auch ein starker Wertverfall entstehen. Die lineare Wertschöpfungskette wird aus diesen Gründen oft mit „take, make, dispose“, also „nehmen, produzieren,entsorgen“, beschrieben.",
    heading: "Denken in Lebenszyklen",
  };

  const textmainKreis = {
    text: `Die Idee der Kreislaufwirtschaft (Englisch: Circular Economy) orientiert sich an Kreisläufen, die in der Natur zu finden sind. Dort entstehen keine Abfälle, da Nährstoffe verwertet werden und als Basis für neues Leben dienen. 
    Schließt man Kreisläufe, können demnach Ressourcen geschont, schädliche Emissionen und Energieverschwendung reduziert und Abfälle vermieden werden.  
    
    Das aktuell vorherrschende, lineare Wirtschaftssystem Wegwerfwirtschaft wird oft als Gegenteil der Kreislaufwirtschaft bezeichnet. Es führt zu hoher Energie- und Ressourcenverschwendung und letztendlich zu einer Übernutzung endlicher Ressourcen auf der Erde.
    
    Die Etablierung einer Kreislaufwirtschaft gilt als notwendiger Schritt auf dem Weg zur Klimaneutralität. Nachhaltigkeits-Expert:innen gehen davon aus, dass bis 2050 die Rohstoffe von drei Erden benötigt werden, um den Markt zu befriedigen, wenn weiter an der Linearwirtschaft festgehalten wird.`,
    heading: "Kreislaufwirtschaft",
  };

  const [text, setText] = useState(textmainKreis);
  const [textFixed, setTextFixed] = useState();
  const [app, setApp] = useState(2);
  const [resizeer, setResize] = useState("2px");

  React.useEffect(() => {
    imageMapResize();
    if (app === 1) {
      setText(textmain);
    } else {
      setText(textmainKreis);
    }
    setTextFixed(false);

    function handleResize() {
      imageMapResize();
      setTimeout(() => {
        setResize("1px");
      }, 500);
    }
    window.addEventListener("resize", handleResize);
  }, [app]);

  let onChangeRadio = (e) => {
    setApp(e.target.value);
  };

  return (
    <>
    <Row>
    <nav style={{
      height:"80px",
      display: "flex",
justifyContent: "space-between",
width:"100%"
    }}>
      <a href="https://www.estandards-mittelstand.de/" target="blank" style={{
        backgroundColor:"rgb(237, 237, 237)",
        width:"100%",
      }}>
        <img src="mk4s.png" alt="Logo Mittelstand 4.0 Kompetenzzentrum eStandards" style={{
          margin: "20px",
          height: "50px"
        }}/>
      </a>  
      </nav>
    </Row>
      <Row>
        <Col
          xs={{ order: 1, span: 24 }}
          sm={{ order: 1, span: 24 }}
          md={{ order: 1, span: 9 }}
          lg={{ order: 1, span: 9 }}
          xxl={{ order: 1, span: 12 }}
        >
          <Row>
            <div style={{ marginLeft: "40%", marginTop: "100px" }}>
              <Row>
                <Radio.Group
                  onChange={onChangeRadio}
                  value={app}
                  defaultValue={2}
                >
                  <Space direction="vertical">
                    <Radio value={1}>
                      <label className="Linearwirtschaft">
                        Linearwirtschaft
                      </label>
                    </Radio>
                    <Radio value={2}>
                      <label className="Kreislaufwirtschaft">
                        Kreislaufwirtschaft
                      </label>
                    </Radio>
                  </Space>
                </Radio.Group>
              </Row>
              <Row>
                <p className="KlickeLine1">
                  Klicke auf die Grafik für mehr Informationen
                </p>
              </Row>
            </div>
          </Row>
          <Row>
            <div
              style={{
                paddingTop: "10%",
                paddingLeft: "10%",
                paddingRight: "10%",
                width: "100%",
              }}
            >
              <p className="para">
                <span
                  style={{
                    fontFamily: "Comfortaa",
                    fontStyle: "normal",
                    fontWeight: "bold",
                    fontSize: "42px",
                    lineHeight: "60px",
                    overflowWrap: "break-word",
                  }}
                >
                  {text?.heading ||
                    (app === 1 ? textmain.heading : textmainKreis.heading)}
                </span>
                <br />
                {text?.text || (app === 1 ? textmain.text : textmainKreis.text)}
              </p>
            </div>
          </Row>
        </Col>
        <Col
          xs={{ order: 2, span: 24 }}
          sm={{ order: 2, span: 24 }}
          md={{ order: 2, span: 15 }}
          lg={{ order: 2, span: 15 }}
          xxl={{ order: 2, span: 12 }}
        >
          <img
            src={app === 1 ? linie : kreis}
            useMap="#image-map"
            style={{
              maxWidth: "100%",
              height: "auto",
              display: app === 2 ? "none" : "",
            }}
          />

          <img
            src={app === 1 ? linie : kreis}
            useMap="#image-map-full"
            style={{
              maxWidth: "100%",
              height: "auto",
              display: app === 1 ? "none" : "",
            }}
          />

          <map
            name="image-map"
            fake={resizeer}
            style={{ padding: resizeer, display: app === 2 ? "none" : "" }}
          >
            <area
              coords="170,153,273,56,380,159,385,231,465,309,540,317,568,334,562,370,484,385,434,373,361,317,275,266"
              shape="poly"
              onMouseEnter={() => {
                if (app === 1) {
                  setText({
                    text: "Zur Herstellung von Produkten werden verschiedene Materialien und Rohstoffe verwendet. Dabei wird zwischen erneuerbaren und nicht erneuerbaren sowie primären und sekundären Rohstoffen unterschieden. Rohstoffe wie Metall und Glas können mit geringen Qualitätsverlusten recycelt und somit als Sekundärrohstoff verwendet werden.",
                    heading: "Rohstoffe",
                  });
                } else {
                  setText({
                    text: "Zur Herstellung von Produkten werden verschiedene Materialien und Rohstoffe verwendet. Dabei wird zwischen erneuerbaren und nicht erneuerbaren sowie primären und sekundären Rohstoffen unterschieden. Rohstoffe wie Metall und Glas können mit geringen Qualitätsverlusten recycelt und somit als Sekundärrohstoff verwendet werden.",
                    heading: "Rohstoffe",
                  });
                }
              }}
              onMouseLeave={() => {
                setText(textFixed);
              }}
              onClick={() => {
                setTextFixed({
                  text: "Zur Herstellung von Produkten werden verschiedene Materialien und Rohstoffe verwendet. Dabei wird zwischen erneuerbaren und nicht erneuerbaren sowie primären und sekundären Rohstoffen unterschieden. Rohstoffe wie Metall und Glas können mit geringen Qualitätsverlusten recycelt und somit als Sekundärrohstoff verwendet werden.",
                  heading: "Rohstoffe",
                });
              }}
            />
            <area
              coords="554,312,605,279,577,209,639,171,663,250,671,261,767,262,790,295,761,313,713,313,636,340,573,362,580,328"
              shape="poly"
              onMouseEnter={() => {
                if (app === 1) {
                  setText({
                    text: "Das Produktdesign hat einen maßgeblichen Einfluß auf alle vorgelagerten und nachgelagerten Prozesse. In dieser Phase entscheidet sich beispielsweise, ob ein Produkt für eine lange Nutzung oder als Einwegprodukt konzipiert wird. Materialwahl, Verpackung, Produktion, zeitgemäßes oder zeitloses Design und viele weitere Parameter beeinflussen schon in der Designphase den weiteren Lebensweg des Produkts. Ein Produktdesigner hat viele Anforderungen zu erfüllen und viele Parameter zu beachten. Ein Ansatz Produkte und Prozesse nachhaltig zu gestalten ist EcoDesign. [Mehr Dazu]",
                    heading: "Design",
                  });
                } else {
                  setText({
                    text: "Eco Design ist ein Gestaltungsansatz für Produkte, mit dem Ziel Umweltbelastungen über den gesamten Produktlebenszyklus zu mindern. Durch verbesserte Produktgestaltung können Produzenten in der Produktplanungs- und -designphase einen positiven Einfluss auf den gesamten Lebensweg des Produktes nehmen. Eco Design ist ein systematischer und umfassender Gestaltungsansatz, der verschiedene Prinzipien und Methodiken bereitstellt, an denen sich Produzenten orientieren können.",
                    heading: " Eco Design",
                  });
                }
              }}
              onMouseLeave={() => {
                setText(textFixed);
              }}
              onClick={() => {
                if (app === 1) {
                  setTextFixed({
                    text: "Das Produktdesign hat einen maßgeblichen Einfluß auf alle vorgelagerten und nachgelagerten Prozesse. In dieser Phase entscheidet sich beispielsweise, ob ein Produkt für eine lange Nutzung oder als Einwegprodukt konzipiert wird. Materialwahl, Verpackung, Produktion, zeitgemäßes oder zeitloses Design und viele weitere Parameter beeinflussen schon in der Designphase den weiteren Lebensweg des Produkts. Ein Produktdesigner hat viele Anforderungen zu erfüllen und viele Parameter zu beachten. Ein Ansatz Produkte und Prozesse nachhaltig zu gestalten ist EcoDesign. [Mehr Dazu]",
                    heading: "Design",
                  });
                } else {
                  setTextFixed({
                    text: "Eco Design ist ein Gestaltungsansatz für Produkte, mit dem Ziel Umweltbelastungen über den gesamten Produktlebenszyklus zu mindern. Durch verbesserte Produktgestaltung können Produzenten in der Produktplanungs- und -designphase einen positiven Einfluss auf den gesamten Lebensweg des Produktes nehmen. Eco Design ist ein systematischer und umfassender Gestaltungsansatz, der verschiedene Prinzipien und Methodiken bereitstellt, an denen sich Produzenten orientieren können.",
                    heading: "Eco Design",
                  });
                }
              }}
            />
            <area
              coords="786,262,863,284,902,223,978,180,1021,201,1001,268,974,327,961,359,987,408,974,446,941,443,879,359,778,321,807,296"
              shape="poly"
              onMouseEnter={() => {
                if (app === 1) {
                  setText({
                    text: "Je nach Funktion und Form des Produktes, eignen sich verschiedene Herstellungsverfahren. Bei der Wahl des geeigneten Herstellungsverfahren, sollten die Ressourcenverbräuche verglichen werden. Additive Herstellungsmethoden, wie der 3D Druck sind durch die geringen Nebenprodukte aus Umweltsicht attraktiv.",
                    heading: "Produktion",
                  });
                } else {
                  setText({
                    text: "Je nach Funktion und Form des Produktes, eignen sich verschiedene Herstellungsverfahren. Bei der Wahl des geeigneten Herstellungsverfahren, sollten die Ressourcenverbräuche verglichen werden. Additive Herstellungsmethoden, wie der 3D Druck sind durch die geringen Nebenprodukte aus Umweltsicht attraktiv.",
                    heading: "Produktion",
                  });
                }
              }}
              onMouseLeave={() => {
                setText(textFixed);
              }}
              onClick={() => {
                if (app === 1) {
                  setTextFixed({
                    text: "Je nach Funktion und Form des Produktes, eignen sich verschiedene Herstellungsverfahren. Bei der Wahl des geeigneten Herstellungsverfahren, sollten die Ressourcenverbräuche verglichen werden. Additive Herstellungsmethoden, wie der 3D Druck sind durch die geringen Nebenprodukte aus Umweltsicht attraktiv.",
                    heading: "Produktion",
                  });
                } else {
                  setTextFixed({
                    text: "Je nach Funktion und Form des Produktes, eignen sich verschiedene Herstellungsverfahren. Bei der Wahl des geeigneten Herstellungsverfahren, sollten die Ressourcenverbräuche verglichen werden. Additive Herstellungsmethoden, wie der 3D Druck sind durch die geringen Nebenprodukte aus Umweltsicht attraktiv.",
                    heading: "Produktion",
                  });
                }
              }}
            />
            <area
              coords="949,456,979,459,994,428,1012,460,1086,449,1125,526,1087,589,1050,603,1021,596,1012,629,978,641,960,611"
              shape="poly"
              onMouseEnter={() => {
                if (app === 1) {
                  setText({
                    text: "In linearen Wirtschaftssystemen konzertriert sich der Vertrieb vor allem darauf Waren und Dienstleistungen zum Kunden zu bringen. Dazu wird, je nach Produkt, ein entsprechendes Logistiknetz genutzt oder aufgebaut. In der Kreislaufwirtschaft erweitern sich die Aufgaben des Vertriebs. Der Kunde wird stärker eingebunden, Rücknahmesysteme werden etabliert und neue Services und Vertriebskanäle entstehen, die dem Kunden eine umfassendere User Experience bieten. Moderne, innovative Vertriebswege bieten großes Potential Kunden zu binden und die steigende Nachfrage nach nachhaltigen Produkten und Dienstleistungen zu befriedigen.",
                    heading: "Vertrieb",
                  });
                } else {
                  setText({
                    text: "In linearen Wirtschaftssystemen konzertriert sich der Vertrieb vor allem darauf Waren und Dienstleistungen zum Kunden zu bringen. Dazu wird, je nach Produkt, ein entsprechendes Logistiknetz genutzt oder aufgebaut. In der Kreislaufwirtschaft erweitern sich die Aufgaben des Vertriebs. Der Kunde wird stärker eingebunden, Rücknahmesysteme werden etabliert und neue Services und Vertriebskanäle entstehen, die dem Kunden eine umfassendere User Experience bieten. Moderne, innovative Vertriebswege bieten großes Potential Kunden zu binden und die steigende Nachfrage nach nachhaltigen Produkten und Dienstleistungen zu befriedigen.",
                    heading: "Vertrieb",
                  });
                }
              }}
              onMouseLeave={() => {
                setText(textFixed);
              }}
              onClick={() => {
                if (app === 1) {
                  setTextFixed({
                    text: "In linearen Wirtschaftssystemen konzertriert sich der Vertrieb vor allem darauf Waren und Dienstleistungen zum Kunden zu bringen. Dazu wird, je nach Produkt, ein entsprechendes Logistiknetz genutzt oder aufgebaut. In der Kreislaufwirtschaft erweitern sich die Aufgaben des Vertriebs. Der Kunde wird stärker eingebunden, Rücknahmesysteme werden etabliert und neue Services und Vertriebskanäle entstehen, die dem Kunden eine umfassendere User Experience bieten. Moderne, innovative Vertriebswege bieten großes Potential Kunden zu binden und die steigende Nachfrage nach nachhaltigen Produkten und Dienstleistungen zu befriedigen.",
                    heading: "Vertrieb",
                  });
                } else {
                  setTextFixed({
                    text: "In linearen Wirtschaftssystemen konzertriert sich der Vertrieb vor allem darauf Waren und Dienstleistungen zum Kunden zu bringen. Dazu wird, je nach Produkt, ein entsprechendes Logistiknetz genutzt oder aufgebaut. In der Kreislaufwirtschaft erweitern sich die Aufgaben des Vertriebs. Der Kunde wird stärker eingebunden, Rücknahmesysteme werden etabliert und neue Services und Vertriebskanäle entstehen, die dem Kunden eine umfassendere User Experience bieten. Moderne, innovative Vertriebswege bieten großes Potential Kunden zu binden und die steigende Nachfrage nach nachhaltigen Produkten und Dienstleistungen zu befriedigen.",
                    heading: "Vertrieb",
                  });
                }
              }}
            />
            <area
              coords="954,625,965,651,1001,648,987,691,1024,740,1007,802,950,812,906,778,867,802,839,786,846,749,907,701"
              shape="poly"
              onMouseEnter={() => {
                if (app === 1) {
                  setText({
                    text: "In vielen Anwendungen wird der Umwelteinfluss der Nutzungsphase unterschätzt. Für die meisten Produkte gilt jedoch, je länger die Produkte genutzt werden, umso geringer der Materialaufwand und damit der Ressourcenverbrauch. Im Hinblick auf die Kreislaufwirtschaft bedeutet das, dass mit einer Verlängerung der Nutzungsphase die Neuproduktion von Gütern verringert wird aber sich der Servicebedarf erhöht. Somit werden Dienstleistungspotenziale geschaffen, die Raum für innovative Serviceleistungen bieten. Kunden werden gebunden und Ressourcenintensive Industrien minimiert.",
                    heading: "Nutzung",
                  });
                } else {
                  setText({
                    text: "In vielen Anwendungen wird der Umwelteinfluss der Nutzungsphase unterschätzt. Für die meisten Produkte gilt jedoch, je länger die Produkte genutzt werden, umso geringer der Materialaufwand und damit der Ressourcenverbrauch. Im Hinblick auf die Kreislaufwirtschaft bedeutet das, dass mit einer Verlängerung der Nutzungsphase die Neuproduktion von Gütern verringert wird aber sich der Servicebedarf erhöht. Somit werden Dienstleistungspotenziale geschaffen, die Raum für innovative Serviceleistungen bieten. Kunden werden gebunden und Ressourcenintensive Industrien minimiert.",
                    heading: "Nutzung",
                  });
                }
              }}
              onMouseLeave={() => {
                setText(textFixed);
              }}
              onClick={() => {
                if (app === 1) {
                  setTextFixed({
                    text: "In vielen Anwendungen wird der Umwelteinfluss der Nutzungsphase unterschätzt. Für die meisten Produkte gilt jedoch, je länger die Produkte genutzt werden, umso geringer der Materialaufwand und damit der Ressourcenverbrauch. Im Hinblick auf die Kreislaufwirtschaft bedeutet das, dass mit einer Verlängerung der Nutzungsphase die Neuproduktion von Gütern verringert wird aber sich der Servicebedarf erhöht. Somit werden Dienstleistungspotenziale geschaffen, die Raum für innovative Serviceleistungen bieten. Kunden werden gebunden und Ressourcenintensive Industrien minimiert.",
                    heading: "Nutzung",
                  });
                } else {
                  setTextFixed({
                    text: "In vielen Anwendungen wird der Umwelteinfluss der Nutzungsphase unterschätzt. Für die meisten Produkte gilt jedoch, je länger die Produkte genutzt werden, umso geringer der Materialaufwand und damit der Ressourcenverbrauch. Im Hinblick auf die Kreislaufwirtschaft bedeutet das, dass mit einer Verlängerung der Nutzungsphase die Neuproduktion von Gütern verringert wird aber sich der Servicebedarf erhöht. Somit werden Dienstleistungspotenziale geschaffen, die Raum für innovative Serviceleistungen bieten. Kunden werden gebunden und Ressourcenintensive Industrien minimiert.",
                    heading: "Nutzung",
                  });
                }
              }}
            />
            <area
              coords="851,807,761,838,720,838,715,924,640,917,593,883,600,802,586,794,566,763,593,738,706,776,829,761,829,789"
              shape="poly"
              onMouseEnter={() => {
                if (app === 1) {
                  setText({
                    text: "Das Nutzungsende eines Produktes ist dann erreicht, wenn es von niemanden weitergenutzt wird. Das heißt, wenn es weder vom Erstnutzer noch von einem anderen Nutzer weiterverwendet wird. Dies kann beispielsweise bei einem nicht reparierbaren Defekt eines Produktes der Fall sein, bei dem das Produkt nicht mehr den gewünschten Zweck erfüllt. Ein anderer Grund für das Nutzungsende kann die Ablösung des Produktes durch ein moderneres sein, beispielsweise wenn es nicht mehr dem aktuellen Trend entspricht. Durch die Gestaltung von ästhetisch zeitlosen oder modularen Produkten kann dieser Grund für das Nutzungsende hinausgezögert werden.",
                    heading: "Nutzungsende",
                  });
                } else {
                  setText({
                    text: "Das Nutzungsende eines Produktes ist dann erreicht, wenn es von niemanden weitergenutzt wird. Das heißt, wenn es weder vom Erstnutzer noch von einem anderen Nutzer weiterverwendet wird. Dies kann beispielsweise bei einem nicht reparierbaren Defekt eines Produktes der Fall sein, bei dem das Produkt nicht mehr den gewünschten Zweck erfüllt. Ein anderer Grund für das Nutzungsende kann die Ablösung des Produktes durch ein moderneres sein, beispielsweise wenn es nicht mehr dem aktuellen Trend entspricht. Durch die Gestaltung von ästhetisch zeitlosen oder modularen Produkten kann dieser Grund für das Nutzungsende hinausgezögert werden.",
                    heading: "Nutzungsende",
                  });
                }
              }}
              onMouseLeave={() => {
                setText(textFixed);
              }}
              onClick={() => {
                if (app === 1) {
                  setTextFixed({
                    text: "Das Nutzungsende eines Produktes ist dann erreicht, wenn es von niemanden weitergenutzt wird. Das heißt, wenn es weder vom Erstnutzer noch von einem anderen Nutzer weiterverwendet wird. Dies kann beispielsweise bei einem nicht reparierbaren Defekt eines Produktes der Fall sein, bei dem das Produkt nicht mehr den gewünschten Zweck erfüllt. Ein anderer Grund für das Nutzungsende kann die Ablösung des Produktes durch ein moderneres sein, beispielsweise wenn es nicht mehr dem aktuellen Trend entspricht. Durch die Gestaltung von ästhetisch zeitlosen oder modularen Produkten kann dieser Grund für das Nutzungsende hinausgezögert werden.",
                    heading: "Nutzungsende",
                  });
                } else {
                  setTextFixed({
                    text: "Das Nutzungsende eines Produktes ist dann erreicht, wenn es von niemanden weitergenutzt wird. Das heißt, wenn es weder vom Erstnutzer noch von einem anderen Nutzer weiterverwendet wird. Dies kann beispielsweise bei einem nicht reparierbaren Defekt eines Produktes der Fall sein, bei dem das Produkt nicht mehr den gewünschten Zweck erfüllt. Ein anderer Grund für das Nutzungsende kann die Ablösung des Produktes durch ein moderneres sein, beispielsweise wenn es nicht mehr dem aktuellen Trend entspricht. Durch die Gestaltung von ästhetisch zeitlosen oder modularen Produkten kann dieser Grund für das Nutzungsende hinausgezögert werden.",
                    heading: "Nutzungsende",
                  });
                }
              }}
            />
            <area
              coords="570,785,553,753,581,733,507,716,439,721,385,757,359,780,341,807,277,826,256,856,266,909,310,921,348,908,377,895,363,848,368,828,406,819,491,776"
              shape="poly"
              onMouseEnter={() => {
                if (app === 1) {
                  setText({
                    text: "Nach dem Nutzungsende eines Produktes, wird dieses, sofern nicht einzelne Komponenten oder Materialien wiederverwendet oder recycelt werden, entsorgt. In Bezug auf die Abfallwirtschaft ist das Ziel der Kreislaufwirtschaft die stoffliche Verwertung nicht vermeidbarer Abfälle. Weiterhin sollen Innovation dazu beitragen die Abfallwirtschaft zu einer Quelle für die Beschaffung von Rohstoffen für die Produktion von Gütern weiterzuentwickeln. Nicht verwertbare Abfälle müssen bevor sie in Deponien abgelagert oder thermisch verwertet werden, aufwendig mechanisch, biologisch oder thermisch behandelt werden, wodurch weitere Umweltwirkungen und Kosten entstehen.",
                    heading: "Entsorgung",
                  });
                } else {
                  setText({
                    text: "Nach dem Nutzungsende eines Produktes, wird dieses, sofern nicht einzelne Komponenten oder Materialien wiederverwendet oder recycelt werden, entsorgt. In Bezug auf die Abfallwirtschaft ist das Ziel der Kreislaufwirtschaft die stoffliche Verwertung nicht vermeidbarer Abfälle. Weiterhin sollen Innovation dazu beitragen die Abfallwirtschaft zu einer Quelle für die Beschaffung von Rohstoffen für die Produktion von Gütern weiterzuentwickeln. Nicht verwertbare Abfälle müssen bevor sie in Deponien abgelagert oder thermisch verwertet werden, aufwendig mechanisch, biologisch oder thermisch behandelt werden, wodurch weitere Umweltwirkungen und Kosten entstehen.",
                    heading: "Entsorgung",
                  });
                }
              }}
              onMouseLeave={() => {
                setText(textFixed);
              }}
              onClick={() => {
                if (app === 1) {
                  setTextFixed({
                    text: "Nach dem Nutzungsende eines Produktes, wird dieses, sofern nicht einzelne Komponenten oder Materialien wiederverwendet oder recycelt werden, entsorgt. In Bezug auf die Abfallwirtschaft ist das Ziel der Kreislaufwirtschaft die stoffliche Verwertung nicht vermeidbarer Abfälle. Weiterhin sollen Innovation dazu beitragen die Abfallwirtschaft zu einer Quelle für die Beschaffung von Rohstoffen für die Produktion von Gütern weiterzuentwickeln. Nicht verwertbare Abfälle müssen bevor sie in Deponien abgelagert oder thermisch verwertet werden, aufwendig mechanisch, biologisch oder thermisch behandelt werden, wodurch weitere Umweltwirkungen und Kosten entstehen.",
                    heading: "Entsorgung",
                  });
                } else {
                  setTextFixed({
                    text: "Nach dem Nutzungsende eines Produktes, wird dieses, sofern nicht einzelne Komponenten oder Materialien wiederverwendet oder recycelt werden, entsorgt. In Bezug auf die Abfallwirtschaft ist das Ziel der Kreislaufwirtschaft die stoffliche Verwertung nicht vermeidbarer Abfälle. Weiterhin sollen Innovation dazu beitragen die Abfallwirtschaft zu einer Quelle für die Beschaffung von Rohstoffen für die Produktion von Gütern weiterzuentwickeln. Nicht verwertbare Abfälle müssen bevor sie in Deponien abgelagert oder thermisch verwertet werden, aufwendig mechanisch, biologisch oder thermisch behandelt werden, wodurch weitere Umweltwirkungen und Kosten entstehen.",
                    heading: "Entsorgung",
                  });
                }
              }}
            />
          </map>

          <map
            name="image-map-full"
            fake={resizeer}
            style={{ padding: resizeer, display: app === 1 ? "none" : "" }}
          >
            <area
              coords="170,153,273,56,380,159,385,231,465,309,540,317,568,334,562,370,484,385,434,373,361,317,275,266"
              shape="poly"
              onMouseEnter={() => {
                if (app === 1) {
                  setText({
                    text: "Zur Herstellung von Produkten werden verschiedene Materialien und Rohstoffe verwendet. Dabei wird zwischen erneuerbaren und nicht erneuerbaren sowie primären und sekundären Rohstoffen unterschieden. Rohstoffe wie Metall und Glas können mit geringen Qualitätsverlusten recycelt und somit als Sekundärrohstoff verwendet werden.",
                    heading: "Rohstoffe",
                  });
                } else {
                  setText({
                    text: "Zur Herstellung von Produkten werden verschiedene Materialien und Rohstoffe verwendet. Dabei wird zwischen erneuerbaren und nicht erneuerbaren sowie primären und sekundären Rohstoffen unterschieden. Rohstoffe wie Metall und Glas können mit geringen Qualitätsverlusten recycelt und somit als Sekundärrohstoff verwendet werden.",
                    heading: "Rohstoffe",
                  });
                }
              }}
              onMouseLeave={() => {
                setText(textFixed);
              }}
              onClick={() => {
                setTextFixed({
                  text: "Zur Herstellung von Produkten werden verschiedene Materialien und Rohstoffe verwendet. Dabei wird zwischen erneuerbaren und nicht erneuerbaren sowie primären und sekundären Rohstoffen unterschieden. Rohstoffe wie Metall und Glas können mit geringen Qualitätsverlusten recycelt und somit als Sekundärrohstoff verwendet werden.",
                  heading: "Rohstoffe",
                });
              }}
            />
            <area
              coords="554,312,605,279,577,209,639,171,663,250,671,261,767,262,790,295,761,313,713,313,636,340,573,362,580,328"
              shape="poly"
              onMouseEnter={() => {
                if (app === 1) {
                  setText({
                    text: "Das Produktdesign hat einen maßgeblichen Einfluß auf alle vorgelagerten und nachgelagerten Prozesse. In dieser Phase entscheidet sich beispielsweise, ob ein Produkt für eine lange Nutzung oder als Einwegprodukt konzipiert wird. Materialwahl, Verpackung, Produktion, zeitgemäßes oder zeitloses Design und viele weitere Parameter beeinflussen schon in der Designphase den weiteren Lebensweg des Produkts. Ein Produktdesigner hat viele Anforderungen zu erfüllen und viele Parameter zu beachten. Ein Ansatz Produkte und Prozesse nachhaltig zu gestalten ist EcoDesign. [Mehr Dazu]",
                    heading: "Design",
                  });
                } else {
                  setText({
                    text: "Eco Design ist ein Gestaltungsansatz für Produkte, mit dem Ziel Umweltbelastungen über den gesamten Produktlebenszyklus zu mindern. Durch verbesserte Produktgestaltung können Produzenten in der Produktplanungs- und -designphase einen positiven Einfluss auf den gesamten Lebensweg des Produktes nehmen. Eco Design ist ein systematischer und umfassender Gestaltungsansatz, der verschiedene Prinzipien und Methodiken bereitstellt, an denen sich Produzenten orientieren können.",
                    heading: " Eco Design",
                  });
                }
              }}
              onMouseLeave={() => {
                setText(textFixed);
              }}
              onClick={() => {
                if (app === 1) {
                  setTextFixed({
                    text: "Das Produktdesign hat einen maßgeblichen Einfluß auf alle vorgelagerten und nachgelagerten Prozesse. In dieser Phase entscheidet sich beispielsweise, ob ein Produkt für eine lange Nutzung oder als Einwegprodukt konzipiert wird. Materialwahl, Verpackung, Produktion, zeitgemäßes oder zeitloses Design und viele weitere Parameter beeinflussen schon in der Designphase den weiteren Lebensweg des Produkts. Ein Produktdesigner hat viele Anforderungen zu erfüllen und viele Parameter zu beachten. Ein Ansatz Produkte und Prozesse nachhaltig zu gestalten ist EcoDesign. [Mehr Dazu]",
                    heading: "Design",
                  });
                } else {
                  setTextFixed({
                    text: "Eco Design ist ein Gestaltungsansatz für Produkte, mit dem Ziel Umweltbelastungen über den gesamten Produktlebenszyklus zu mindern. Durch verbesserte Produktgestaltung können Produzenten in der Produktplanungs- und -designphase einen positiven Einfluss auf den gesamten Lebensweg des Produktes nehmen. Eco Design ist ein systematischer und umfassender Gestaltungsansatz, der verschiedene Prinzipien und Methodiken bereitstellt, an denen sich Produzenten orientieren können.",
                    heading: "Eco Design",
                  });
                }
              }}
            />
            <area
              coords="786,262,863,284,902,223,978,180,1021,201,1001,268,974,327,961,359,987,408,974,446,941,443,879,359,778,321,807,296"
              shape="poly"
              onMouseEnter={() => {
                if (app === 1) {
                  setText({
                    text: "Je nach Funktion und Form des Produktes, eignen sich verschiedene Herstellungsverfahren. Bei der Wahl des geeigneten Herstellungsverfahren, sollten die Ressourcenverbräuche verglichen werden. Additive Herstellungsmethoden, wie der 3D Druck sind durch die geringen Nebenprodukte aus Umweltsicht attraktiv.",
                    heading: "Produktion",
                  });
                } else {
                  setText({
                    text: "Je nach Funktion und Form des Produktes, eignen sich verschiedene Herstellungsverfahren. Bei der Wahl des geeigneten Herstellungsverfahren, sollten die Ressourcenverbräuche verglichen werden. Additive Herstellungsmethoden, wie der 3D Druck sind durch die geringen Nebenprodukte aus Umweltsicht attraktiv.",
                    heading: "Produktion",
                  });
                }
              }}
              onMouseLeave={() => {
                setText(textFixed);
              }}
              onClick={() => {
                if (app === 1) {
                  setTextFixed({
                    text: "Je nach Funktion und Form des Produktes, eignen sich verschiedene Herstellungsverfahren. Bei der Wahl des geeigneten Herstellungsverfahren, sollten die Ressourcenverbräuche verglichen werden. Additive Herstellungsmethoden, wie der 3D Druck sind durch die geringen Nebenprodukte aus Umweltsicht attraktiv.",
                    heading: "Produktion",
                  });
                } else {
                  setTextFixed({
                    text: "Je nach Funktion und Form des Produktes, eignen sich verschiedene Herstellungsverfahren. Bei der Wahl des geeigneten Herstellungsverfahren, sollten die Ressourcenverbräuche verglichen werden. Additive Herstellungsmethoden, wie der 3D Druck sind durch die geringen Nebenprodukte aus Umweltsicht attraktiv.",
                    heading: "Produktion",
                  });
                }
              }}
            />
            <area
              coords="949,456,979,459,994,428,1012,460,1086,449,1125,526,1087,589,1050,603,1021,596,1012,629,978,641,960,611"
              shape="poly"
              onMouseEnter={() => {
                if (app === 1) {
                  setText({
                    text: "In linearen Wirtschaftssystemen konzertriert sich der Vertrieb vor allem darauf Waren und Dienstleistungen zum Kunden zu bringen. Dazu wird, je nach Produkt, ein entsprechendes Logistiknetz genutzt oder aufgebaut. In der Kreislaufwirtschaft erweitern sich die Aufgaben des Vertriebs. Der Kunde wird stärker eingebunden, Rücknahmesysteme werden etabliert und neue Services und Vertriebskanäle entstehen, die dem Kunden eine umfassendere User Experience bieten. Moderne, innovative Vertriebswege bieten großes Potential Kunden zu binden und die steigende Nachfrage nach nachhaltigen Produkten und Dienstleistungen zu befriedigen.",
                    heading: "Vertrieb",
                  });
                } else {
                  setText({
                    text: "In linearen Wirtschaftssystemen konzertriert sich der Vertrieb vor allem darauf Waren und Dienstleistungen zum Kunden zu bringen. Dazu wird, je nach Produkt, ein entsprechendes Logistiknetz genutzt oder aufgebaut. In der Kreislaufwirtschaft erweitern sich die Aufgaben des Vertriebs. Der Kunde wird stärker eingebunden, Rücknahmesysteme werden etabliert und neue Services und Vertriebskanäle entstehen, die dem Kunden eine umfassendere User Experience bieten. Moderne, innovative Vertriebswege bieten großes Potential Kunden zu binden und die steigende Nachfrage nach nachhaltigen Produkten und Dienstleistungen zu befriedigen.",
                    heading: "Vertrieb",
                  });
                }
              }}
              onMouseLeave={() => {
                setText(textFixed);
              }}
              onClick={() => {
                if (app === 1) {
                  setTextFixed({
                    text: "In linearen Wirtschaftssystemen konzertriert sich der Vertrieb vor allem darauf Waren und Dienstleistungen zum Kunden zu bringen. Dazu wird, je nach Produkt, ein entsprechendes Logistiknetz genutzt oder aufgebaut. In der Kreislaufwirtschaft erweitern sich die Aufgaben des Vertriebs. Der Kunde wird stärker eingebunden, Rücknahmesysteme werden etabliert und neue Services und Vertriebskanäle entstehen, die dem Kunden eine umfassendere User Experience bieten. Moderne, innovative Vertriebswege bieten großes Potential Kunden zu binden und die steigende Nachfrage nach nachhaltigen Produkten und Dienstleistungen zu befriedigen.",
                    heading: "Vertrieb",
                  });
                } else {
                  setTextFixed({
                    text: "In linearen Wirtschaftssystemen konzertriert sich der Vertrieb vor allem darauf Waren und Dienstleistungen zum Kunden zu bringen. Dazu wird, je nach Produkt, ein entsprechendes Logistiknetz genutzt oder aufgebaut. In der Kreislaufwirtschaft erweitern sich die Aufgaben des Vertriebs. Der Kunde wird stärker eingebunden, Rücknahmesysteme werden etabliert und neue Services und Vertriebskanäle entstehen, die dem Kunden eine umfassendere User Experience bieten. Moderne, innovative Vertriebswege bieten großes Potential Kunden zu binden und die steigende Nachfrage nach nachhaltigen Produkten und Dienstleistungen zu befriedigen.",
                    heading: "Vertrieb",
                  });
                }
              }}
            />
            <area
              coords="954,625,965,651,1001,648,987,691,1024,740,1007,802,950,812,906,778,867,802,839,786,846,749,907,701"
              shape="poly"
              onMouseEnter={() => {
                if (app === 1) {
                  setText({
                    text: "In vielen Anwendungen wird der Umwelteinfluss der Nutzungsphase unterschätzt. Für die meisten Produkte gilt jedoch, je länger die Produkte genutzt werden, umso geringer der Materialaufwand und damit der Ressourcenverbrauch. Im Hinblick auf die Kreislaufwirtschaft bedeutet das, dass mit einer Verlängerung der Nutzungsphase die Neuproduktion von Gütern verringert wird aber sich der Servicebedarf erhöht. Somit werden Dienstleistungspotenziale geschaffen, die Raum für innovative Serviceleistungen bieten. Kunden werden gebunden und Ressourcenintensive Industrien minimiert.",
                    heading: "Nutzung",
                  });
                } else {
                  setText({
                    text: "In vielen Anwendungen wird der Umwelteinfluss der Nutzungsphase unterschätzt. Für die meisten Produkte gilt jedoch, je länger die Produkte genutzt werden, umso geringer der Materialaufwand und damit der Ressourcenverbrauch. Im Hinblick auf die Kreislaufwirtschaft bedeutet das, dass mit einer Verlängerung der Nutzungsphase die Neuproduktion von Gütern verringert wird aber sich der Servicebedarf erhöht. Somit werden Dienstleistungspotenziale geschaffen, die Raum für innovative Serviceleistungen bieten. Kunden werden gebunden und Ressourcenintensive Industrien minimiert.",
                    heading: "Nutzung",
                  });
                }
              }}
              onMouseLeave={() => {
                setText(textFixed);
              }}
              onClick={() => {
                if (app === 1) {
                  setTextFixed({
                    text: "In vielen Anwendungen wird der Umwelteinfluss der Nutzungsphase unterschätzt. Für die meisten Produkte gilt jedoch, je länger die Produkte genutzt werden, umso geringer der Materialaufwand und damit der Ressourcenverbrauch. Im Hinblick auf die Kreislaufwirtschaft bedeutet das, dass mit einer Verlängerung der Nutzungsphase die Neuproduktion von Gütern verringert wird aber sich der Servicebedarf erhöht. Somit werden Dienstleistungspotenziale geschaffen, die Raum für innovative Serviceleistungen bieten. Kunden werden gebunden und Ressourcenintensive Industrien minimiert.",
                    heading: "Nutzung",
                  });
                } else {
                  setTextFixed({
                    text: "In vielen Anwendungen wird der Umwelteinfluss der Nutzungsphase unterschätzt. Für die meisten Produkte gilt jedoch, je länger die Produkte genutzt werden, umso geringer der Materialaufwand und damit der Ressourcenverbrauch. Im Hinblick auf die Kreislaufwirtschaft bedeutet das, dass mit einer Verlängerung der Nutzungsphase die Neuproduktion von Gütern verringert wird aber sich der Servicebedarf erhöht. Somit werden Dienstleistungspotenziale geschaffen, die Raum für innovative Serviceleistungen bieten. Kunden werden gebunden und Ressourcenintensive Industrien minimiert.",
                    heading: "Nutzung",
                  });
                }
              }}
            />
            <area
              coords="851,807,761,838,720,838,715,924,640,917,593,883,600,802,586,794,566,763,593,738,706,776,829,761,829,789"
              shape="poly"
              onMouseEnter={() => {
                if (app === 1) {
                  setText({
                    text: "Das Nutzungsende eines Produktes ist dann erreicht, wenn es von niemanden weitergenutzt wird. Das heißt, wenn es weder vom Erstnutzer noch von einem anderen Nutzer weiterverwendet wird. Dies kann beispielsweise bei einem nicht reparierbaren Defekt eines Produktes der Fall sein, bei dem das Produkt nicht mehr den gewünschten Zweck erfüllt. Ein anderer Grund für das Nutzungsende kann die Ablösung des Produktes durch ein moderneres sein, beispielsweise wenn es nicht mehr dem aktuellen Trend entspricht. Durch die Gestaltung von ästhetisch zeitlosen oder modularen Produkten kann dieser Grund für das Nutzungsende hinausgezögert werden.",
                    heading: "Nutzungsende",
                  });
                } else {
                  setText({
                    text: "Das Nutzungsende eines Produktes ist dann erreicht, wenn es von niemanden weitergenutzt wird. Das heißt, wenn es weder vom Erstnutzer noch von einem anderen Nutzer weiterverwendet wird. Dies kann beispielsweise bei einem nicht reparierbaren Defekt eines Produktes der Fall sein, bei dem das Produkt nicht mehr den gewünschten Zweck erfüllt. Ein anderer Grund für das Nutzungsende kann die Ablösung des Produktes durch ein moderneres sein, beispielsweise wenn es nicht mehr dem aktuellen Trend entspricht. Durch die Gestaltung von ästhetisch zeitlosen oder modularen Produkten kann dieser Grund für das Nutzungsende hinausgezögert werden.",
                    heading: "Nutzungsende",
                  });
                }
              }}
              onMouseLeave={() => {
                setText(textFixed);
              }}
              onClick={() => {
                if (app === 1) {
                  setTextFixed({
                    text: "Das Nutzungsende eines Produktes ist dann erreicht, wenn es von niemanden weitergenutzt wird. Das heißt, wenn es weder vom Erstnutzer noch von einem anderen Nutzer weiterverwendet wird. Dies kann beispielsweise bei einem nicht reparierbaren Defekt eines Produktes der Fall sein, bei dem das Produkt nicht mehr den gewünschten Zweck erfüllt. Ein anderer Grund für das Nutzungsende kann die Ablösung des Produktes durch ein moderneres sein, beispielsweise wenn es nicht mehr dem aktuellen Trend entspricht. Durch die Gestaltung von ästhetisch zeitlosen oder modularen Produkten kann dieser Grund für das Nutzungsende hinausgezögert werden.",
                    heading: "Nutzungsende",
                  });
                } else {
                  setTextFixed({
                    text: "Das Nutzungsende eines Produktes ist dann erreicht, wenn es von niemanden weitergenutzt wird. Das heißt, wenn es weder vom Erstnutzer noch von einem anderen Nutzer weiterverwendet wird. Dies kann beispielsweise bei einem nicht reparierbaren Defekt eines Produktes der Fall sein, bei dem das Produkt nicht mehr den gewünschten Zweck erfüllt. Ein anderer Grund für das Nutzungsende kann die Ablösung des Produktes durch ein moderneres sein, beispielsweise wenn es nicht mehr dem aktuellen Trend entspricht. Durch die Gestaltung von ästhetisch zeitlosen oder modularen Produkten kann dieser Grund für das Nutzungsende hinausgezögert werden.",
                    heading: "Nutzungsende",
                  });
                }
              }}
            />
            <area
              coords="570,785,553,753,581,733,507,716,439,721,385,757,359,780,341,807,277,826,256,856,266,909,310,921,348,908,377,895,363,848,368,828,406,819,491,776"
              shape="poly"
              onMouseEnter={() => {
                if (app === 1) {
                  setText({
                    text: "Nach dem Nutzungsende eines Produktes, wird dieses, sofern nicht einzelne Komponenten oder Materialien wiederverwendet oder recycelt werden, entsorgt. In Bezug auf die Abfallwirtschaft ist das Ziel der Kreislaufwirtschaft die stoffliche Verwertung nicht vermeidbarer Abfälle. Weiterhin sollen Innovation dazu beitragen die Abfallwirtschaft zu einer Quelle für die Beschaffung von Rohstoffen für die Produktion von Gütern weiterzuentwickeln. Nicht verwertbare Abfälle müssen bevor sie in Deponien abgelagert oder thermisch verwertet werden, aufwendig mechanisch, biologisch oder thermisch behandelt werden, wodurch weitere Umweltwirkungen und Kosten entstehen.",
                    heading: "Entsorgung",
                  });
                } else {
                  setText({
                    text: "Nach dem Nutzungsende eines Produktes, wird dieses, sofern nicht einzelne Komponenten oder Materialien wiederverwendet oder recycelt werden, entsorgt. In Bezug auf die Abfallwirtschaft ist das Ziel der Kreislaufwirtschaft die stoffliche Verwertung nicht vermeidbarer Abfälle. Weiterhin sollen Innovation dazu beitragen die Abfallwirtschaft zu einer Quelle für die Beschaffung von Rohstoffen für die Produktion von Gütern weiterzuentwickeln. Nicht verwertbare Abfälle müssen bevor sie in Deponien abgelagert oder thermisch verwertet werden, aufwendig mechanisch, biologisch oder thermisch behandelt werden, wodurch weitere Umweltwirkungen und Kosten entstehen.",
                    heading: "Entsorgung",
                  });
                }
              }}
              onMouseLeave={() => {
                setText(textFixed);
              }}
              onClick={() => {
                if (app === 1) {
                  setTextFixed({
                    text: "Nach dem Nutzungsende eines Produktes, wird dieses, sofern nicht einzelne Komponenten oder Materialien wiederverwendet oder recycelt werden, entsorgt. In Bezug auf die Abfallwirtschaft ist das Ziel der Kreislaufwirtschaft die stoffliche Verwertung nicht vermeidbarer Abfälle. Weiterhin sollen Innovation dazu beitragen die Abfallwirtschaft zu einer Quelle für die Beschaffung von Rohstoffen für die Produktion von Gütern weiterzuentwickeln. Nicht verwertbare Abfälle müssen bevor sie in Deponien abgelagert oder thermisch verwertet werden, aufwendig mechanisch, biologisch oder thermisch behandelt werden, wodurch weitere Umweltwirkungen und Kosten entstehen.",
                    heading: "Entsorgung",
                  });
                } else {
                  setTextFixed({
                    text: "Nach dem Nutzungsende eines Produktes, wird dieses, sofern nicht einzelne Komponenten oder Materialien wiederverwendet oder recycelt werden, entsorgt. In Bezug auf die Abfallwirtschaft ist das Ziel der Kreislaufwirtschaft die stoffliche Verwertung nicht vermeidbarer Abfälle. Weiterhin sollen Innovation dazu beitragen die Abfallwirtschaft zu einer Quelle für die Beschaffung von Rohstoffen für die Produktion von Gütern weiterzuentwickeln. Nicht verwertbare Abfälle müssen bevor sie in Deponien abgelagert oder thermisch verwertet werden, aufwendig mechanisch, biologisch oder thermisch behandelt werden, wodurch weitere Umweltwirkungen und Kosten entstehen.",
                    heading: "Entsorgung",
                  });
                }
              }}
            />

            <area
              style={{ display: app === 1 ? "none" : "" }}
              coords="820,748,817,691,831,654,855,624,883,603,922,593,944,570,927,554,893,555,862,566,836,581,815,604,795,630,778,658,772,688,773,721,776,756"
              shape="poly"
              onMouseEnter={() => {
                if (app === 1) {
                  setText({
                    text: "Durch die Wiederverwendung von Produkten wird deren Nutzungsphase verlängert und langfristige weniger Produkte hergestellt. Werden gebrauchte Produkte weiterverkauft oder verschenkt und von weiteren Nutzer:innen verwendet, können Neukäufe vermieden werden.",
                    heading: "Wiederverwenden",
                  });
                } else {
                  setText({
                    text: "Durch die Wiederverwendung von Produkten wird deren Nutzungsphase verlängert und langfristige weniger Produkte hergestellt. Werden gebrauchte Produkte weiterverkauft oder verschenkt und von weiteren Nutzer:innen verwendet, können Neukäufe vermieden werden.",
                    heading: "Wiederverwenden",
                  });
                }
              }}
              onMouseLeave={() => {
                setText(textFixed);
              }}
              onClick={() => {
                if (app === 1) {
                  setTextFixed({
                    text: "Durch die Wiederverwendung von Produkten wird deren Nutzungsphase verlängert und langfristige weniger Produkte hergestellt. Werden gebrauchte Produkte weiterverkauft oder verschenkt und von weiteren Nutzer:innen verwendet, können Neukäufe vermieden werden.",
                    heading: "Wiederverwenden",
                  });
                } else {
                  setTextFixed({
                    text: "Durch die Wiederverwendung von Produkten wird deren Nutzungsphase verlängert und langfristige weniger Produkte hergestellt. Werden gebrauchte Produkte weiterverkauft oder verschenkt und von weiteren Nutzer:innen verwendet, können Neukäufe vermieden werden.",
                    heading: "Wiederverwenden",
                  });
                }
              }}
            />
            <area
              style={{ display: app === 1 ? "none" : "" }}
              coords="999,681,1027,687,1053,730,1055,781,1037,821,1014,842,972,854,941,852,905,840,889,823,872,810,904,783,914,795,931,802,967,810,987,805,1002,793,1014,768,1012,740,1006,726,995,716"
              shape="poly"
              onMouseEnter={() => {
                if (app === 1) {
                  setText({
                    text: "Die Reparatur von Produkten führt dazu, dass die Nutzungsphase verlängert und weniger ressourcenintensive Neuprodukte produziert werden. Durch die Reparatur von Produkten können zudem neue, innovative Serviceangebote entstehen. Die Reparaturfähigkeit eines Produkts muss schon im Designprozess berücksichtigt werden, z. B. durch den Entwurf modular aufgebauter Produkte, bei denen sich einzelne Bauteile leicht austauschen lassen.",
                    heading: "Reparieren",
                  });
                } else {
                  setText({
                    text: "Die Reparatur von Produkten führt dazu, dass die Nutzungsphase verlängert und weniger ressourcenintensive Neuprodukte produziert werden. Durch die Reparatur von Produkten können zudem neue, innovative Serviceangebote entstehen. Die Reparaturfähigkeit eines Produkts muss schon im Designprozess berücksichtigt werden, z. B. durch den Entwurf modular aufgebauter Produkte, bei denen sich einzelne Bauteile leicht austauschen lassen.",
                    heading: "Reparieren",
                  });
                }
              }}
              onMouseLeave={() => {
                setText(textFixed);
              }}
              onClick={() => {
                if (app === 1) {
                  setTextFixed({
                    text: "Die Reparatur von Produkten führt dazu, dass die Nutzungsphase verlängert und weniger ressourcenintensive Neuprodukte produziert werden. Durch die Reparatur von Produkten können zudem neue, innovative Serviceangebote entstehen. Die Reparaturfähigkeit eines Produkts muss schon im Designprozess berücksichtigt werden, z. B. durch den Entwurf modular aufgebauter Produkte, bei denen sich einzelne Bauteile leicht austauschen lassen.",
                    heading: "Reparieren",
                  });
                } else {
                  setTextFixed({
                    text: "Die Reparatur von Produkten führt dazu, dass die Nutzungsphase verlängert und weniger ressourcenintensive Neuprodukte produziert werden. Durch die Reparatur von Produkten können zudem neue, innovative Serviceangebote entstehen. Die Reparaturfähigkeit eines Produkts muss schon im Designprozess berücksichtigt werden, z. B. durch den Entwurf modular aufgebauter Produkte, bei denen sich einzelne Bauteile leicht austauschen lassen.",
                    heading: "Reparieren",
                  });
                }
              }}
            />
            <area
              style={{ display: app === 1 ? "none" : "" }}
              coords="498,302,510,200,547,152,593,128,644,122,680,128,715,150,739,183,754,219,761,252,728,248,724,230,707,194,676,171,653,162,611,161,593,168,571,182,546,221,542,249,539,285,518,306"
              shape="poly"
              onMouseEnter={() => {
                if (app === 1) {
                  setText({
                    text: "Beim Reduzieren geht es auf der einen Seite um die effiziente Nutzung von Materialien, ohne dabei die Nutzungsanforderungen einzuschränken. Auf der anderen Seite bezieht sich das Reduktionsprinzip aber auch auf die effiziente Nutzung von Ressourcen und Rohstoffen über den gesamten Lebenszyklus eines Produktes. Reduzieren bedeutet also auch, dass für ein Produkt unter Umständen zunächst mehr Material eingesetzt wird, das Produkt aber so gestaltet ist, dass es langfristig genutzt wird – was auf lange Sicht den Materialeinsatz verringert.",
                    heading: "Reduzieren",
                  });
                } else {
                  setText({
                    text: "Beim Reduzieren geht es auf der einen Seite um die effiziente Nutzung von Materialien, ohne dabei die Nutzungsanforderungen einzuschränken. Auf der anderen Seite bezieht sich das Reduktionsprinzip aber auch auf die effiziente Nutzung von Ressourcen und Rohstoffen über den gesamten Lebenszyklus eines Produktes. Reduzieren bedeutet also auch, dass für ein Produkt unter Umständen zunächst mehr Material eingesetzt wird, das Produkt aber so gestaltet ist, dass es langfristig genutzt wird – was auf lange Sicht den Materialeinsatz verringert.",
                    heading: "Reduzieren",
                  });
                }
              }}
              onMouseLeave={() => {
                setText(textFixed);
              }}
              onClick={() => {
                if (app === 1) {
                  setTextFixed({
                    text: "Beim Reduzieren geht es auf der einen Seite um die effiziente Nutzung von Materialien, ohne dabei die Nutzungsanforderungen einzuschränken. Auf der anderen Seite bezieht sich das Reduktionsprinzip aber auch auf die effiziente Nutzung von Ressourcen und Rohstoffen über den gesamten Lebenszyklus eines Produktes. Reduzieren bedeutet also auch, dass für ein Produkt unter Umständen zunächst mehr Material eingesetzt wird, das Produkt aber so gestaltet ist, dass es langfristig genutzt wird – was auf lange Sicht den Materialeinsatz verringert.",
                    heading: "Reduzieren",
                  });
                } else {
                  setTextFixed({
                    text: "Beim Reduzieren geht es auf der einen Seite um die effiziente Nutzung von Materialien, ohne dabei die Nutzungsanforderungen einzuschränken. Auf der anderen Seite bezieht sich das Reduktionsprinzip aber auch auf die effiziente Nutzung von Ressourcen und Rohstoffen über den gesamten Lebenszyklus eines Produktes. Reduzieren bedeutet also auch, dass für ein Produkt unter Umständen zunächst mehr Material eingesetzt wird, das Produkt aber so gestaltet ist, dass es langfristig genutzt wird – was auf lange Sicht den Materialeinsatz verringert.",
                    heading: "Reduzieren",
                  });
                }
              }}
            />
            <area
              style={{ display: app === 1 ? "none" : "" }}
              coords="760,762,715,766,701,671,708,608,724,541,765,471,818,417,854,389,888,394,877,427,833,459,792,510,769,556,755,605,745,658"
              shape="poly"
              onMouseEnter={() => {
                if (app === 1) {
                  setText({
                    text: "Die Wiederaufbereitung von Produkten oder Produktkomponenten führt dazu, dass weniger Ressourcen für die Herstellung neuer Produkte verbraucht werden. So können Komponenten eines ausrangierten Produktes in die Produktion neuer Ware einfließen oder als Ersatzteile für defekte Produkte dienen. Auch das Upcycling, also die gezielte Aufwertung von Produkten und Materialien nach Nutzungsende, führt zu einem geringeren Ressourcenverbrauch.",
                    heading: "Wiederaufbereiten",
                  });
                } else {
                  setText({
                    text: "Die Wiederaufbereitung von Produkten oder Produktkomponenten führt dazu, dass weniger Ressourcen für die Herstellung neuer Produkte verbraucht werden. So können Komponenten eines ausrangierten Produktes in die Produktion neuer Ware einfließen oder als Ersatzteile für defekte Produkte dienen. Auch das Upcycling, also die gezielte Aufwertung von Produkten und Materialien nach Nutzungsende, führt zu einem geringeren Ressourcenverbrauch.",
                    heading: "Wiederaufbereiten",
                  });
                }
              }}
              onMouseLeave={() => {
                setText(textFixed);
              }}
              onClick={() => {
                if (app === 1) {
                  setTextFixed({
                    text: "Die Wiederaufbereitung von Produkten oder Produktkomponenten führt dazu, dass weniger Ressourcen für die Herstellung neuer Produkte verbraucht werden. So können Komponenten eines ausrangierten Produktes in die Produktion neuer Ware einfließen oder als Ersatzteile für defekte Produkte dienen. Auch das Upcycling, also die gezielte Aufwertung von Produkten und Materialien nach Nutzungsende, führt zu einem geringeren Ressourcenverbrauch.",
                    heading: "Wiederaufbereiten",
                  });
                } else {
                  setTextFixed({
                    text: "Die Wiederaufbereitung von Produkten oder Produktkomponenten führt dazu, dass weniger Ressourcen für die Herstellung neuer Produkte verbraucht werden. So können Komponenten eines ausrangierten Produktes in die Produktion neuer Ware einfließen oder als Ersatzteile für defekte Produkte dienen. Auch das Upcycling, also die gezielte Aufwertung von Produkten und Materialien nach Nutzungsende, führt zu einem geringeren Ressourcenverbrauch.",
                    heading: "Wiederaufbereiten",
                  });
                }
              }}
            />
            <area
              style={{ display: app === 1 ? "none" : "" }}
              coords="581,727,544,688,517,641,502,594,497,549,502,516,519,450,528,434,518,401,477,410,460,442,448,482,442,535,438,571,444,615,465,665,478,692,494,713"
              shape="poly"
              onMouseEnter={() => {
                if (app === 1) {
                  setText({
                    text: "Recycling ist eine der bekanntesten Vorgehensweisen, um Produktkreisläufe zu schließen und Materialien effizient wiederzuverwenden. Es beschreibt die Zurückgewinnung von Rohmaterial aus aussortierten oder defekten Produkten, das daraufhin als Eingangsmaterial zur Produktion neuer Produkte genutzt werden. Dadurch entfällt ein Großteil der Umweltwirkungen, die beim Ressourcenabbau anfallen würden. Über die Materialwahl und entsprechende Produktionsverfahren lässt sich stark beeinflussen, wie gut ein Produkt recycelt werden kann.",
                    heading: "Recycling",
                  });
                } else {
                  setText({
                    text: "Recycling ist eine der bekanntesten Vorgehensweisen, um Produktkreisläufe zu schließen und Materialien effizient wiederzuverwenden. Es beschreibt die Zurückgewinnung von Rohmaterial aus aussortierten oder defekten Produkten, das daraufhin als Eingangsmaterial zur Produktion neuer Produkte genutzt werden. Dadurch entfällt ein Großteil der Umweltwirkungen, die beim Ressourcenabbau anfallen würden. Über die Materialwahl und entsprechende Produktionsverfahren lässt sich stark beeinflussen, wie gut ein Produkt recycelt werden kann.",
                    heading: "Recycling",
                  });
                }
              }}
              onMouseLeave={() => {
                setText(textFixed);
              }}
              
              onClick={() => {
                if (app === 1) {
                  setTextFixed({
                    text: "Recycling ist eine der bekanntesten Vorgehensweisen, um Produktkreisläufe zu schließen und Materialien effizient wiederzuverwenden. Es beschreibt die Zurückgewinnung von Rohmaterial aus aussortierten oder defekten Produkten, das daraufhin als Eingangsmaterial zur Produktion neuer Produkte genutzt werden. Dadurch entfällt ein Großteil der Umweltwirkungen, die beim Ressourcenabbau anfallen würden. Über die Materialwahl und entsprechende Produktionsverfahren lässt sich stark beeinflussen, wie gut ein Produkt recycelt werden kann.",
                    heading: "Recycling",
                  });
                } else {
                  setTextFixed({
                    text: "Recycling ist eine der bekanntesten Vorgehensweisen, um Produktkreisläufe zu schließen und Materialien effizient wiederzuverwenden. Es beschreibt die Zurückgewinnung von Rohmaterial aus aussortierten oder defekten Produkten, das daraufhin als Eingangsmaterial zur Produktion neuer Produkte genutzt werden. Dadurch entfällt ein Großteil der Umweltwirkungen, die beim Ressourcenabbau anfallen würden. Über die Materialwahl und entsprechende Produktionsverfahren lässt sich stark beeinflussen, wie gut ein Produkt recycelt werden kann.",
                    heading: "Recycling",
                  });
                }
              }}
            ></area>
          </map>
        </Col>
      </Row>
      <Row>
      <footer style={{display: "flex",flexDirection: "column",paddingTop: "2em", 
          backgroundColor:"rgb(237, 237, 237)", width:"100%", color: "#333", fontSize:"16px", fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif'}}>
        <nav style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          paddingLeft: "1em",
          paddingRight: "1em",

        }}>
          <ol style={{
            listStyle: "none",
            paddingLeft: "0",
            display: "flex",
            flexDirection: "row"
          }}>
            <li style={{marginRight:"2em"}}>
              <a href="/impressum" class="footer-link" style={{color:"#333", textDecoration:"underline"}}>Impressum</a>
            </li> 
            <li style={{marginRight:"2em"}}>
              <a href="/datenschutz" class="footer-link" style={{color:"#333", textDecoration:"underline"}}>Datenschutzinformation</a>
            </li>
          </ol> 
          </nav> 
          <div style={{
              marginTop: "2em",
              padding: "1em",
              display: "flex",
              justifyContent: "flex-end",
              backgroundColor: "white"
            }}>
            <div style={{
              display: "block"
            }}>
              <img src="md.jpg" style={{marginRight: "3em"}} alt="Logo Mittelstand Digital" style={{marginRight:"3em", display: "block", width:"200px", paddingTop:"60px"}}/>
            </div> 
          <div style={{
              display: "block"
            }}>
                <img src="bmwi.png" alt="Logo Bundesministeriums für Wirtschaft und Energie" style={{marginRight:"3em", display: "block", width:"200px"}}/>
          </div>
        </div>
      </footer>
      </Row>
    </>
  );
};

export default App;
